/* eslint-disable import/prefer-default-export */

export const formatFieldName = (field, learnerIdxRef) => `learners[${learnerIdxRef.current}].${field}`;
